import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import * as variables from 'styles/variables';
import { BoxCol } from './Box';

const Container = styled(BoxCol)`

`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    // transition: all 0.6s;
    // overflow-y: hidden;
	max-height: ${({ isCollapsed }) => isCollapsed ? '0' : '100%'};
`;

export const Collapse = (props) => {
	const {
		disable,
		className,
		children,
		defaultValue = false,
		renderButton: RenderButton,
	} = props;

	const [isCollapsed, setCollapsed] = useState(defaultValue);

	const handleClick = () => {
		setCollapsed(!isCollapsed);
	};

	return (
		<Container className={className}>
			<Content isCollapsed={isCollapsed}>
				{children}
			</Content>

			{!disable && (
				<RenderButton isCollapsed={isCollapsed} onClick={handleClick}>
					{isCollapsed ? 'розгорнути' : 'згорнути'}
				</RenderButton>
			)}
		</Container>
	);
};

export const CollapseButton = styled.div`
	position: relative;
	text-align: center;
	margin-bottom: ${({ isCollapsed }) => isCollapsed ? '28px' : '0'};
	color: ${variables.formColors.label};
	
	&:after {
		position: absolute;
		left: calc(50% - 40px);
		content: ' ';
		border-left: 40px solid transparent;
		border-right: 40px solid transparent;
		border-top: 14px solid ${variables.formColors.label};
		
		${({ isCollapsed }) => isCollapsed ? css`
			bottom: -22px;
		` : css`
			bottom: 22px;
			transform: rotate(180deg);	
		`}
	}
`;

Collapse.defaultProps = {
	renderButton: CollapseButton,
	disable: true,
};